import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import * as FileSaver from "file-saver";
import { ActivatedRoute, Router } from "@angular/router";
import buildQuery from "odata-query";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ReportsService } from "../../../../core/services/reports.service";
import { CustomerSettlementHistoryDetailValue } from "../../../../core/models/reports/customerSettlement";
import { LoaderService } from "../../../../core/services/loader.service";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-customer-settlement",
  templateUrl: "./customer-settlement.component.html",
  styleUrls: ["./customer-settlement.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    InputTextModule,
    CardModule,
    ButtonModule,
  ],
})
export class CustomerSettlementComponent implements OnInit, OnChanges {
  customerSettlementDetailLists: CustomerSettlementHistoryDetailValue[] = [];
  filterCustomerSettlementDetailLists: CustomerSettlementHistoryDetailValue[] =
    [];
  TransRecId = "";
  @Input() clientIdFromModal = 0;
  @Output() closeSettlementEvent = new EventEmitter();

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private route: Router,
    private router: ActivatedRoute
  ) {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    this.router.params.subscribe((params: any) => {
      this.TransRecId = params.id;
    });
    /* eslint-enable @typescript-eslint/no-explicit-any */
  }

  ngOnInit(): void {
    this.getCustomerSettlement();
  }

  ngOnChanges() {
    if (this.clientIdFromModal) {
      this.TransRecId = this.clientIdFromModal.toString();
    }
  }

  getCustomerSettlement() {
    this._loaderService.setLoaderState(true);
    const filter = {
      TransRecId: parseInt(this.TransRecId),
    };
    const query = buildQuery({ filter });
    this._reportsService.getCustomerSettlement(query).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.customerSettlementDetailLists = res.data;
          this.filterCustomerSettlementDetailLists =
            this.customerSettlementDetailLists;
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  redirectToClient(client: string) {
    const url = `/clients/active/client-details/${client}`;
    this.route.navigate([url]);
  }

  onTransDateFilter(event: Event) {
    const data = event.target as HTMLInputElement;
    if (data?.value) {
      const filterList = this.customerSettlementDetailLists.filter(x =>
        x.TransDate?.includes(data?.value)
      );
      this.filterCustomerSettlementDetailLists = filterList;
    } else {
      this.filterCustomerSettlementDetailLists =
        this.customerSettlementDetailLists;
    }
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.customerSettlementDetailLists);
  }

  exportExcelForFilterData(
    filterclientlist: CustomerSettlementHistoryDetailValue[]
  ) {
    const object = filterclientlist.map(datum => {
      return {
        ["Date of Settlement"]: new Date(datum.TransDate),
        ["Offset Voucher"]: datum.OffsetTransVoucher,
        ["Account"]: datum.AccountNum,
        ["Created By"]: datum.CreatedBy1,
        ["Offset Currency"]: datum.OffsetCurrency,
        ["Offset Amount"]: datum.OffsetAmount,
        ["Amount Settled"]: datum.SettleAmountMST,
        ["Settled Currency"]: datum.SettleAmountCur,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "CustomerSettlementReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }
  closeSettleEvent() {
    this.closeSettlementEvent.emit();
  }
}
